<template>

    <section class="dd-m-onboarding dd-m-onboarding--presentation"
             v-if="list.length && show">
        <Slick ref="slick" :options="options">
            <onboarding-presentation-item v-for="(item, index) in list"
                                          :item="item"
                                          :is-last="index === (list.length - 1)"
                                          :close="close"
                                          :next="next"
                                          :key="index"></onboarding-presentation-item>
        </Slick>
    </section>

</template>
<script>
    import items from '../data/onboarding.json';
    import SlickOptions from "../providers/slick";
    import OnboardingPresentationItem from "./onboarding-presentation-item";
    import Slick from 'vue-slick';

    export default {
        name: 'onboarding-presentation',
        components: {OnboardingPresentationItem, Slick},
        data: () => {
            return {
                list: [],
                options: new SlickOptions().getSimple(),
                show: false
            }
        },
        mounted() {
            this.list = items;
            this.display();
        },
        methods: {
            display() {
                if (!localStorage.onboardingHasShown) {
                    this.show = true;

                    setTimeout(() => {
                        localStorage.onboardingHasShown = true;
                    }, 1000);
                }
            },
            close() {
                this.show = false;
            },
            next() {
                this.$refs.slick.next();
            }
        }
    }
</script>



// WEBPACK FOOTER //
// resources/site/js/components/onboarding-presentation.vue